export enum TypeConnection {
    API = 'api',
    WEB = 'web',
    WEB_ACTUAL = 'web actual',
    WEB_NEW = 'web nueva',
}